import React from 'react';
import { SlNavigationBar } from '../../../features/navigation/public/SlNavigationBar/SlNavigationBar';

export const NavigationBar = () => <SlNavigationBar />;
